let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("jpQ9N")).then(() => parcelRequire('19eRX'));